export default class PathScheduleRuntime {
    public hour: number = 0;
    public minute: number = 0;
}
